export default __webpack_public_path__ + "static/media/time.99061c65.svg";